import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import Txt from '../../../inputs/textInput.js';
import Lbl from '../../../inputs/label.js';
import objectAssign from 'object-assign';
import { updateWaitingAreaNotifyRoomParticipantsForm } from '../../../../actions/waitingArea';
import { ValidMe } from '../../../../businessLogic/validation.js';

export default function CenterPanelSuspendWaitingArea(props) {
  const [valueForCaller, setValueForCaller] = useState('');
  const [valueForProvider, setValueForProvider] = useState('');
  const [charsLeft, setCharsLeft] = useState(200);
  const [maxChars, setMaxChars] = useState(200);
  const [charsLeftForProvider, setCharsLeftForProvider] = useState(200);
  const [maxCharsForProviders, setMaxCharsForProviders] = useState(200);

  useEffect(() => {
    props.setGetSuspendWAMsgForCallers('');
    props.setGetSuspendWAMsgForProviders('');
  }, []);

  const suspendMessageChange = (value) => {
    value = value.substr(0, 200);
    setCharsLeft(maxChars - value.length);
    setValueForCaller(value);
    props.setGetSuspendWAMsgForCallers(value);
  };

  const suspendMessageForProvidersChange = (value) => {
    value = value.substr(0, 200);
    setCharsLeftForProvider(maxCharsForProviders - value.length);
    setValueForProvider(value);
    props.setGetSuspendWAMsgForProviders(value);
  };

  const getTextAreaValueForCallers = () => {
    return valueForCaller;
  };

  const getTextAreaValueForProviders = () => {
    return valueForProvider;
  };

  return (
    <div className="ui form mrbs">
      <label className="placeholder-label no-bold color-placeholder div-like">
        {APP.LANGUAGE.SuspendWaitingAreaModal.HeaderTitle}
      </label>
      <div>
        <Txt
          textArea
          rows="7"
          focusme="true"
          classes="textarea minHeightTextareaMedium"
          tabIndex="1"
          value={valueForCaller}
          onChange={suspendMessageChange}
          noTitle
          fieldClasses="ui htxl input textarea mrtnull"
          titlePlaceholder=" "
        />
      </div>
      <div className="wa-charsRight small-font-size pdtnull mrtnull mrbm">
        <span>{APP.LANGUAGE.NotifyCaller.CharactersRemaining + charsLeft}</span>
      </div>
      <div className="clear-both" />
      <label className="placeholder-label no-bold color-placeholder div-like">
        {APP.LANGUAGE.SuspendWaitingAreaModal.ProviderHeaderTitle}
      </label>
      <div>
        <Txt
          textArea
          rows="4"
          classes="textarea minHeightTextareaMedium"
          tabIndex="1"
          value={valueForProvider}
          onChange={suspendMessageForProvidersChange}
          noTitle
          fieldClasses="ui htxl input textarea mrtnull"
          titlePlaceholder=" "
        />
      </div>
      <div className="wa-charsRight small-font-size pdtnull mrtnull mrbm">
        <span>{APP.LANGUAGE.NotifyCaller.CharactersRemaining + charsLeftForProvider}</span>
      </div>
    </div>
  );
}
